import cl from "classnames";
import { FC, SVGAttributes, useState } from "react";

import cls from "./AppIconPreview.module.css";

import AppIcon from "@/shared/assets/icons/appIcon.svg";
import AppStoreIcon from "@/shared/assets/icons/appStoreIcon.svg";
import GooglePlayIcon from "@/shared/assets/icons/googlePlayIcon.svg";
import RuStoreBadgeIcon from "@/shared/assets/icons/ruStoreBadgeIcon.svg";
import { StoreType } from "@/shared/lib/detectStoreFromUrl";

interface AppIconProps {
    platform: StoreType;
    iconLink?: string;
    compact?: boolean;
    "data-qa"?: string;
}

export const AppIconPreview = ({
    platform,
    iconLink,
    compact = false,
    "data-qa": dataQa,
}: AppIconProps) => {
    const [failedIconLink, setFailedIconLink] = useState<string | null>(null);
    const storeIconMap: Record<StoreType, FC<SVGAttributes<SVGElement>>> = {
        ios: AppStoreIcon,
        google_play: GooglePlayIcon,
        alt_stores: RuStoreBadgeIcon,
    };
    const StoreIcon = storeIconMap[platform];
    const showPlaceholder = !iconLink || failedIconLink === iconLink;

    return (
        <div className={cl(cls["app-icon-wrapper"], compact && cls.compact)} data-qa={dataQa}>
            {showPlaceholder ? (
                <div className={cls["app-icon-placeholder"]}>
                    <AppIcon aria-hidden="true" />
                </div>
            ) : (
                <img
                    className={cls["app-icon"]}
                    alt=""
                    src={iconLink}
                    onError={() => setFailedIconLink(iconLink || null)}
                />
            )}
            <StoreIcon className={cls["store-icon"]} />
        </div>
    );
};
